import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { BooleanFilterEnum } from '../../../shared/enums/boolean-filter.enum';
import { AreaTypeEnum } from '../../../shared/modules/settings/enums/area-type.enum';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';

/**
 * Proto areas filters
 */
export class ProtoAreasFilters extends ApiRequestFilters {
	/**
	 * Country
	 */
	@TransformInt()
	country?: number;

	/**
	 * Parent
	 */
	@TransformInt()
	parent?: number;

	/**
	 * Types
	 */
	types?: AreaTypeEnum[];

	/**
	 * Hidden
	 */
	hidden?: BooleanFilterEnum;
}
